module.exports = __webpack_public_path__ + "static/lake-haven-logo-b9a73c6b67837668523d710864828d9f.png";